import React, { Suspense } from 'react';
/**
 * Prevents rendering of a Suspense tag during server-side rendering by nakedly rendering the fallback we'd have used for suspense.
 *
 * Only use this if the fallback for server and client are identical.
 */ const SuspenseWithServerFallback = ({ fallback, children })=>{
    if (typeof window === 'undefined') {
        return fallback;
    }
    return /*#__PURE__*/ React.createElement(Suspense, {
        fallback: fallback
    }, children);
};
SuspenseWithServerFallback.displayName = 'SuspenseWithServerFallback';
export default SuspenseWithServerFallback;

//# sourceMappingURL=SuspenseWithServerFallback.js.map